export default __webpack_public_path__ + "static/media/feedback-bad-white.bf261538.png";